import { detailModel } from './detailModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'

export function PageHeader() {

    const { searchParam, updateSearchParam, resetSearchParam, loadData } = detailModel()
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '客户名称',
            fieldName: 'customerName',
            span: 3,
        }
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
            style={{ margin: 'auto', border: '1px solid #d6d6d6' }}
        />
    )
}
